<template>
  <div class="signup full-width flexbox align-center justify-center full-height">
    <el-card class="text-center">
      <img src="https://static.newsbx.com/newsbx/logo/logo-colored.svg" width="180"/>
      <signup-form v-if="signUpFormVisible" />
    </el-card>
  </div>
</template>

<script>
import SignupForm from '@/components/signup/Form'
export default {
  data () {
    return {
      signUpFormVisible: true
    }
  },
  components: {
    SignupForm
  }
}
</script>
